import React, { FC } from 'react'
import classnames from 'classnames'
import Button, { ButtonProps } from '@mui/material/Button'

const TinyButton: FC<React.PropsWithChildren<ButtonProps>> = (props) => {
  const sx = Object.assign({}, props.sx, {
    fontSize: '1rem',
    textTransform: 'none',
    py: theme => theme.spacing(1),
    px: theme => theme.spacing(2),
    m: theme => theme.spacing(0.5),
  })

  return (
    <Button
      sx={ sx }
      {...props}
      className={ props.className }
      size="small"
    />
  )
}

export default TinyButton